import styled from "styled-components";

export const NavTitle = styled.h6`
	font-size: 18px;
	font-weight: bold;
	padding: 10px 20px;
	margin: 0;
`
